import React, { } from 'react';
import { useDispatch, useSelector } from "react-redux";
import '../Css/Map.css';
import { setMapPop } from '../store/api/Modals';
import { Modal } from 'react-bootstrap';
import Map from '../pages/Map.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalMap = (props) => {
    const dispatch = useDispatch();
    const pop = useSelector(state => state.popup.mapPop);
    const { location } = props;
    const { show } = pop;

    const close = () => {
        dispatch(setMapPop({ show: false }));
    }
    return (
        <Modal show={show} size='lg' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span> <FontAwesomeIcon icon={faMapMarkedAlt} size='lg' />&nbsp;
                    انتخاب از نقشه
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />

            </Modal.Header>
            <Modal.Body className='bodyStyle' style={{paddingTop:0}}>
                <Map location={{ lat: location.lat, lng: location.lng, zoom: location.zoom }} />
            </Modal.Body>
        </Modal>
    );
};

export default ModalMap;
